module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("1")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("BEGINNINGS")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("From the founding of Stephen F. Austin State University in Nacogdoches, Texas, in 1923 through World War II and the start of the cold war that was its consequence, the college attracted new residents to the city as students, faculty, and staff and always provided the best show in town. That was true for many educational and cultural reasons, but intercollegiate athletic competition contributed every bit as much, and sometimes more, in making Nacogdoches a college town. Games in Aikman Gym or on Birdwell Field and then Memorial Stadium attracted large crowds for games against archrivals from Sam Houston State Teachers College and later Howard Payne and Abilene Christian Universities.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("This beginning time is remembered as . . . coach Shelton’s era, when one man literally coached every sport . . . the arrival of coaches Gene White, “Red” Willis, M. A. Baumgartner, Bill Pearce, and Ted Jeffries in football and Stan McKewen, Glen Rose, and John O. Stephens in basketball . . . Virginia Broadfoot showing girls how to play basketball . . . June Irwin and Lucille Norton “inventing” the term “Ladyjacks” . . . women playing field hockey and badminton . . . Larry Franks, Van Samford, and Marshall Matterson shooting baskets . . . line coach Ralph Murff, and then nearly all male students, departing for army, navy, and marine corps duty during World War II, leaving 300 or so female students on campus . . . no competitive sports at all between 1942 and 1945 because “there’s a war on, don’t you know” . . . Dick Wright coming home from the war to lead the Lumberjack football team . . . and getting a new football stadium that doubled as a men’s dormitory. These were days of many beginnings, even beginning again after World War II, for the college among the pine trees.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0002.jpg",
      "src": "images/e9781439638378_i0002.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The football team in 1923, the year Stephen F. Austin State Teachers College began operating, were the first Lumberjacks. This picture, taken from the school’s first yearbook, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(", shows, from left to right, (first row) Walker, Alders, Olds, Bates, Shelton, Blackwell, and Sanders; (second row) Putman, Hallmark, Miller, Davis, Hale, Willingham, and Thompson; (third row) coach Robert H. (Bob) Shelton, Garner, Avery, Ray, Russell, Landers, Madkins, Parrish, Crocker, and Crawford. (Courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0003.jpg",
      "src": "images/e9781439638378_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Coach Robert H. (Bob) Shelton, from Dripping Springs, Texas, served as captain of five teams and earned 15 letters in four years of athletic competition at Southwest Texas State Teachers College in San Marcos, Texas, by 1921. Dr. A. W. Birdwell, president-designate of the newly created Stephen F. Austin State Teachers College in Nacogdoches, hired Shelton, a senior, as athletic director for the new school. Coach Shelton, as shown in the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" for 1923, dressed out for practice. The photograph at right shows dean of men Robert Shelton in 1964. (Both courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0004.jpg",
      "src": "images/e9781439638378_i0004.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0005.jpg",
      "src": "images/e9781439638378_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Track and field competition, also coached by Robert Shelton, began at Stephen F. Austin in 1923 and has continued until the present. Members of the squad in 1924 are identified in this photograph in the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" as, from left to right, (first row) Blackwell, Floyd, Willingham, Pitman (with javelin), Hendricks, and Billingsley; (second row) Parker, Bailey, Garner, Redding, Ray, and Baugh. Below, the football team schedule from the 1927 season features “Big Ed” Sharpe, captain and center. (Both courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0006.jpg",
      "src": "images/e9781439638378_i0006.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0007.jpg",
      "src": "images/e9781439638378_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The photograph above depicts action in the Lumberjacks’ final game of the season against Sam Houston State Teachers College, played at Birdwell Field on Thanksgiving Day. Below, a Stephen F. Austin pole-vaulter, identified as “Stagner,” is shown clearing 11 feet, 6 inches to win first place in a meet between Stephen F. Austin and Sam Houston State. No sand pit appears in the photograph to provide a soft landing for the jumper. (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0008.jpg",
      "src": "images/e9781439638378_i0008.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0009.jpg",
      "src": "images/e9781439638378_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Lumberjack track team, coached by Robert Shelton, was depicted in the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" in 1926. The team included, from left to right, (first row) Golub, Shaw, Claunch, Miller, Rochefort, Johnson, and Stanfield; (second row) George, Pate, Todd, Ainsworth, Koonce, Shoultz, and Henderson. Below, Stephen F. Austin president A. W. Birdwell, standing in a business suit at lower left, poses with track team members and Lumberjack fans at a track meet in Nacogdoches during the 1920s. (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0010.jpg",
      "src": "images/e9781439638378_i0010.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0011.jpg",
      "src": "images/e9781439638378_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Ladyjack basketball became a major activity at Stephen F. Austin in the 1970s, but an earlier intramural version of the sport is shown in this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph from the 1920s. Participants are, from left to right, (first row) Pauline Buckner, Loyal Metteaur, and Dalpha Irwin; (second row) Drunetta Nation, Gladys Calloway, Lucille Brashear, Lela Edmonds, coach Virginia Broadfoot, Mable Weaver, Oma Grimes, Anna Belle Lee Burden, and Lorraine Holland; (third row) Nena Flourney, Bertie Rawson, Margaret Lowe, Jewell Davis, Minnie Sealbach, Myrna Holman, Madeline Moore, Reba Crawford, and Charlcey Needham; (fourth row) Angie McNary, Hazel Melvin, Floyd Whittaker, Clara Schenks, Birdie Burkett, Ethel Melvin, Winnie McGaughey, Violet Hanna, Mable Bentley, and Velma Weaver. (Courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0012.jpg",
      "src": "images/e9781439638378_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Virginia Broadfoot (left) was head of physical education for women at Stephen F. Austin in the 1920s. Broadfoot was a graduate of North Texas State Teachers College, located in Denton, Texas. Below is coach Robert Shelton with the men’s basketball squad in 1925. Team members included, from left to right, (first row) Haley Bush, Fritz Thompson, Sam Davis, and Grady Bradley; (second row) Shelton, Joe Davis, Ben Tucker, Richard Wier, and James Parker (captain). (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0013.jpg",
      "src": "images/e9781439638378_i0013.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0014.jpg",
      "src": "images/e9781439638378_i0014.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Stephen F. Austin’s Lumberjack baseball team in 1926 included, from left to right, (first row) Howard Prince, Joe Davis, Everett Walker, C. N. “Choc” Thompson, Sam Davis, Earl Medford, and D. M. Walker; (second row) Hollis Thomas, Leo White, Lee Conner, Sam Frizzell, Eugene Sanders, and Eura Bates. Below are unidentified members of the pep squad in 1931. They wore white dresses and purple jackets to athletic contests to cheer for Lumberjack teams and also hosted a campus dance in the spring. (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0015.jpg",
      "src": "images/e9781439638378_i0015.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0016.jpg",
      "src": "images/e9781439638378_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Above, unidentified women students play field hockey in 1932. The photograph below shows Stephen F. Austin’s 1935 football team, cochampions of the Lone Star Conference. Team members included, from left to right, (sitting) Dominy, Little, Bailey, Bush, Mills, Freeze, Hough, McGee, and Barwick; (kneeling) Shanks, Halbert, Sitton, Hurst, Wagstaff, Maberry, West, Lawrence, and Roquemore; (standing) coach Gene White, Gaston, Schillings, Ramsey, Birdwell, Honeycutt, Warren, Porter, Hawkins, McPhail, and line coach Burk. (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0017.jpg",
      "src": "images/e9781439638378_i0017.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0018.jpg",
      "src": "images/e9781439638378_i0018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Pictured is the cover of an official program from a football game played against the Sam Houston State Teachers College Bearcats on November 23, 1935, Stephen F. Austin’s cochampionship season. The Sam Houston Bearcats remain the Lumberjacks’ principal rivals in all athletic competition. (Photograph by Hardy Meredith; courtesy the East Texas Research Center.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0019.jpg",
      "src": "images/e9781439638378_i0019.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("An outstanding Lumberjack basketball player, Lawrence Franks (left) pursued a career in higher education and succeeded Robert Shelton as dean of men at Stephen F. Austin State University in 1964. He later moved to a similar post at the University of Texas, Austin. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "36%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0020.jpg",
      "src": "images/e9781439638378_i0020.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A fellow Lumberjack, Van Samford, succeeded Franks as dean of men at Stephen F. Austin. Samford later directed the university’s placement office. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0021.jpg",
      "src": "images/e9781439638378_i0021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Marshall Matterson (right), a major contributor to the success of Stephen F. Austin’s basketball teams from 1937 through 1939, later owned and operated the Stephen F. Austin Theatre, a movie theater on North Street one block north of the campus. Below, Emmett Battise, from Livingston, was one of several Alabama-Coushatta Indians who played on Stephen F. Austin athletic teams. Nicknamed “E,” Battise played guard. (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0022.jpg",
      "src": "images/e9781439638378_i0022.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0023.jpg",
      "src": "images/e9781439638378_i0023.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Above is coach Robert Shelton’s fifth consecutive Lone Star Conference champion track team in 1936. Members were, from left to right, (first row) Hanigan, Sitton, C. Colwell, Grenshaw, Crawford, and Clayton; (second row) coach Shelton, Ed Hanigan, Tompkins, Jones, S. Colwell, and Irick; (third row) Hawkins, Wagstaff, Honeycutt, Massey, and Ramsey. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0024.jpg",
      "src": "images/e9781439638378_i0024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Line coach Ralph Murff (left), who worked at Stephen F. Austin State Teachers College from 1937 until he left for military service during World War II, and head coach M. A. (Dutch) Baumgarten, who joined the staff in 1940, are pictured with their sons. Stephen F. Austin State Teachers College did not field teams from 1942 through 1945. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "41%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0025.jpg",
      "src": "images/e9781439638378_i0025.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Stephen F. Austin State Teachers College did not field conference athletic teams during World War II, but the student body, mostly women, continued intramural athletics. In 1944, Janelle Tyer (left) and June Irwin won the doubles badminton championship. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "47%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0026.jpg",
      "src": "images/e9781439638378_i0026.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Richard Carlyle (Dick) Wright, captain of the Lumberjack football team in 1946, represented the resumption of competitive athletic programs. Wright, a veteran, entered Texas A&M College before the war but decided to return to his hometown to complete his college education. The Dick Wright Award, endowed by the Wright family, annually honors a male athlete who best exemplifies Dick Wright’s desire, dedication, and determination as a Lumberjack. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0027.jpg",
      "src": "images/e9781439638378_i0027.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Stephen F. Austin State Teachers College resumed football after World War II with Ted L. Jefferies (left) as athletic director and head coach. Above, Jefferies is shown with, from left to right, assistant coaches Stanford McKewen (also head basketball coach and later registrar of the university), Joe Gallagher, and Harold Fischer, who succeeded Jefferies as head coach in 1956. Below are members of the cheerleading squad in 1950, identified from left to right only as Harriet, Betty, Dana, Nan, and Sue. (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0028.jpg",
      "src": "images/e9781439638378_i0028.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0029.jpg",
      "src": "images/e9781439638378_i0029.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Shown at right, Elvin (Buddy) Lowery takes a shot in the Shelton Gym during a Lone Star Conference game. Lowery began at Panola College in Carthage, Texas, and then played for the Lumberjacks under coach John O. Stephens from 1957 to 1959. Lowery led the Lumberjacks with 391 points and was named to the all-conference team in 1959. Below, Lowery receives the Todd Memorial Award from Stephen F. Austin State Teachers College president Ralph W. Steen (right) and distinguished alumnus Bob Murphey (left) in 1959. Lowery later played professionally for the Detroit Pistons in the National Basketball League. (Both courtesy Elvin Lowery.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0030.jpg",
      "src": "images/e9781439638378_i0030.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0031.jpg",
      "src": "images/e9781439638378_i0031.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Aikman Gym, constructed on Stephen F. Austin State Teachers College’s campus near the corner of East Austin and Raguet Streets, hosted basketball games and physical education classes from 1924 until the completion of Shelton Gym in 1961. Nacogdoches businessman Frank Aikman donated $12,000 to construct the gym. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0032.jpg",
      "src": "images/e9781439638378_i0032.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Murray Shaw, wearing jersey No. 31, played in Aikman Gym in 1950 and later served as a regent of the university and a successful businessman based in Austin, Texas. The Murray Shaw Reception Room in William R. Johnson Coliseum honors Shaw’s service. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0033.jpg",
      "src": "images/e9781439638378_i0033.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Stephen F. Austin State Teachers College Lumberjacks began playing football in Memorial Stadium, located east of Raguet Street on the college campus, in 1946. The stadium was part of a complex that included a park and swimming pool dedicated to the memory of Nacogdoches-area residents who lost their lives during World War II. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0034.jpg",
      "src": "images/e9781439638378_i0034.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The stands on the west side of Memorial Stadium included dormitory rooms, training facilities, and the athletic equipment room. The stadium also hosted commencement exercises and other campus convocations. It was razed in 1972 when Lumberjack Stadium, later Homer Bryce Stadium, was completed. Memorial Stadium’s steel bleachers were sold to the Nacogdoches Independent School District and remain in service at Dragon Stadium near Loop 224 in northeast Nacogdoches. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photograph courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0035.jpg",
      "src": "images/e9781439638378_i0035.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Above, unidentified twirlers in the Lumberjack Marching Band and freshman students line up on the Memorial Stadium field to welcome the Lumberjack football team in 1950. Below, cheerleaders pose before a game. From left to right are (kneeling) Kathy Bratton, John Hamilton and Marilyn Moyers; (standing) George Cannon, Sue Neal, and John McDonald. (Both "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stone Fort")]), _vm._v(" photographs courtesy SFA Alumni Association.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439638378_i0036.jpg",
      "src": "images/e9781439638378_i0036.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a2c44e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439638378_c01.vue
// module id = 78
// module chunks = 0